
import ReactDOM from "react-dom";
import { useEffect, useState } from "react";

import {fetchLanguage} from "./blocksLang";


import app from "../components/app";

import JSONEditor from "../components/jsonEditor";
import {languages} from "../components/utility";

function findMismatchedKeysWithValues(data) {
    const keysEnglish = Object.keys(languageSettings);
    const keysOther = Object.keys(data);
    
    const mismatchedKeys = keysEnglish.filter(function(v){
        if(keysOther.indexOf(v) !== -1) {
            return false;
        }
        return true;
    });
    const result = {};

    mismatchedKeys.forEach(key => {
        result[key] = languageSettings[key];
    });
  
    return result;
}

const fetchData = async function(data) {
    const response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
        method:"POST",
        body:JSON.stringify(data)
    });
    return await response.json();
}



const languageSettings = {
    "saved": "Saved",
    "save": "Save",
    "style": "Style",
    "blocks": "Blocks",
    "elements": "Elements",
    "background_width": "Background Width",
    "inset": "Inset",
    "full_bleed": "Full Bleed",
    "font": "Font",
    "size": "Size",
    "font_align": "Font Align",
    "text_color": "Text Color",
    "background": "Background",
    "overlay_color": "Overlay Color",
    "padding": "Padding",
    "divider": "Divider",
    "divider_color": "Divider Color",
    "show_map": "Show Map",
    "grid_size": "Grid Size",
    "swiper": "Swiper",
    "icon": "Icon",
    "border_style": "Border Style",
    "border_color": "Border Color",
    "border_size": "Border Size",
    "border_radius": "Corners Radius",
    "link": "Link",
    "open_in_new_window": "Open in New Window",
    "icon_color": "Icon Color",
    "icon_background": "Icon Background",
    "icon_active_color": "Active Color",
    "icon_active_background": "Active Background",
    "icon_align": "Icon Align",
    "ratio": "Ratio",
    "corners_radius": "Corners Radius",
    "edit": "Edit",
    "up": "Up",
    "down": "Down",
    "copy": "Copy",
    "clone": "Clone",
    "preview": "Preview",
    "delete": "Delete",
    "remove": "Remove",
    "view": "View",
    "add": "Add",
    "add_section": "Add Section",
    "add_master_block": "Add Master Block",
    "add_block": "Add Block",
    "add_page": "Add Page",
    "templates": "Templates",
    "master_blocks": "Master Blocks",
    "search": "Search",
    "choose_image":"CHOOSE IMAGE",
    "library":"Library",
    "generated_images":"Generated Images",
    "web_address":"Web Address",
    "email":"Email",
    "address":"Address",
    "social":"Social",
    "link_editor":"LINK EDITOR",
    "default":"Default",
    "none":"None",
    "content":"Content",
    "all_sections":"All Sections",
    "flip":"Flip",
    "colors":"Colors",
    "gradients":"Gradients",
    "generate":"Generate",
    "patterns":"Patterns",
    "backgrounds":"Backgrounds",
    "custom_upload":"Custom Upload",
    "social_link":"Social Link",
    "clear":"Clear",
    "add_more":"Add More",
    "map":"Map",
    "divider_visibility":"Divider Visibility",
    "divider_size":"Divider Size",
    "divider_type":"Divider Type",
    "onlyAllowedFormats": "Only JPG and PNG images are allowed",
    "validImageUrl": "Please enter a valid Image URL",
    "confirmDelete": "Are you sure that you want to delete?",
    "imageUrl": "IMAGE URL",
    "upload": "Upload",
    "searchIcons": "Search for icons",
    "cover": "Cover",
    "contain": "Contain",
    "scale": "Scale",
    "rounded": "Rounded",
    "circle": "Circle",
    "alert": "Alert",
    "notSupportedInSimulation": "This feature is not supported in simulation mode, as it requires native phone API integration. However, it should work seamlessly on the mobile device.",
    "writeTopic": "Write some topic",
    "generateParagraph": "Generate paragraph for",
    "makeThis": "Make this",
    "aiTextCreator": "AI Text Creator",
    "addCredits": "Add Credits",
    "describeDescription": "Describe your description in a sentence or two and the AI will help you rephrase it.",
    "createText": "Create Text", 
    "fullBleed": "Full Bleed",
    "line": "Line",
    "dash": "Dash",
    "show": "Show",
    "indicatorType": "Indicator Type",
    "activeColor": "Active Color",
    "indicatorColor": "Indicator Color",
    "startTime": "Start Time",
    "endTime": "End Time",
    "alwaysOpen": "Always Open",
    "applyTwentyFourFormat": "Apply Twenty Four Format",
    "chooseBackground": "CHOOSE BACKGROUND",
    "chooseImage": "CHOOSE IMAGE",
    "linkEditor": "Link Editor",
    "text": "Text",
    "url": "Url", 
    "whatsapp": "WhatsApp",
    "skype": "Skype",
    "phone": "Phone",
    "to": "TO",
    "whatsappNumber": "Whatsapp Number",
    "phoneNumber": "PHONE NUMBER",
    "addSection": "Add a Section",
    "enterId": "Enter your ID / Username / Number",
    "internalPage": "Internal Page",
    "selectPage": "Select Page",
    "subject": "SUBJECT",
    "body": "BODY",
    "writeTextForImageGeneration": "Write some text for generate image",
    "generateImages": "Generate images",
    "validUrl": "Please enter a valid URL",
    "validEmail": "Please enter a valid email address",
    "enterPhoneNumber": "Please enter a valid phone number",
    "enterWhatsAppNumber": "Please enter a valid whatsapp number",
    "oldGenerateImages": "Old Generate Images",
    "simple": "Simple",
    "simplify":"Simplify",
    "convertToHeading":"Convert to Heading",
    "shorten":"Shorten",
    "regenerate":"Regenerate",
    "shorter": "Shorter",
    "makeShorter":"Make Shorter",
    "simplifyLanguage":"Simplify Language",
    "heading": "Heading",
    "useText": "Use Text",
    "language": "Language", 
    "selectIcon": "Select Icon",
    "select": "Select",  
    "icons": "Icons",
    "writeAboutAiGeneratedImages": "Write something about images generated by AI",
    "editSection": "Edit Section",
    "from_Color":"From Color",
    "to_Color":"To Color",
    "create_aI_text":"Create AI Text",
    "move":"Move",
    "remove_section":"Remove Section",
    "are_you_sure":"Are you sure you want to remove this section?",
    "business":"Business",
    "radio_podcast":"Radio/Podcast",
    "restaurant_food":"Restaurant & Food",
    "online_store":"Online Store",
    "events":"Events",
    "event":"Events",
    "education":"Education",
    "religion_worship":"Religion/Worship",
    "health_wellness":"Health & Wellness",
    "news_magazine":"News & Magazine",
    "location_places":"Location & Places",
    "others":"Others",
    "cancel":"Cancel",
    "dont_show_this_again":"Don't show this again",
    "done":"Done",
    "btn_margin":"Button Margin",
    "icon_margin":"Icon Margin",
    "facebook":"Facebook",
    "twitter":"Twitter",
    "linkedin":"Linkedin",
    "maxSize":"Max File size is 5MB",
    "home":"Home",
    "home_page":"Home Page",
    "about":"About",
    "contact":"Contact",
    "foodcourt":"Food Court",
    "store":"Store",
    "about_us":"About Us",
    "contact_us":"Contact Us",
    "code":"Code Page",
    "google_class":"Google Class",
    "fitness":"Fitness",
    "directory":"Directory",
    "services":"Directory",
    "news":"News",
    "dating":"Dating",
    "quiz":"Quiz",
    "inquiry":"Inquiry",
    "audio":"Audio",
    "shareContent":"Share Content",
    "credits":"Credits",
    "meetAi":"Meet the AI Text Creator",
    "meetAiDes":"Create custom content with the AI Text Creator. Simply answer a few questions and it’ll do the work for you.",
    "top":"Top",
    "right":"Right",
    "bottom":"Bottom",
    "left":"Left",
    "purchaseSuccessful":"Purchase successful! Your credits are now available.",
    "currencyNotSupported":"To add the credits, please reach out to our support team at support@appypie.com.",
    "failedAddCredits":"To add the credits, please reach out to our support team at support@appypie.com.",
    "textgenDes":"How many text generation do you want to use?",
    "calculatePrice":"Starts from ### text generation. Select your text generation limit to calculate price",
    "fundsRequired":"Funds Required",
    "TextQuantity":"Text generation quantity",
    "TextPrice":"Price per text generation",
    "reqFunds":"Required Funds",
    "avFunds":"Available funds",
    "taxAmount":"Tax Amount",
    "totalReqFunds":"Total Funds Required",
    "addCurrButton":"Add & Generate Text",
    "addFunds":"Add Funds",
    "autoLoadLink":"Auto Load Page",
    "header_background":"Header Background",
    "showHeader":"Enable In-App browser navigation (Back and Forward) support",
    "linkSpacing":"Link Spacing",
    "elementSpacing":"Element Spacing",
    "logoDimension":"Logo Dimension",
    "menuBackground":"Menu Background",
    "menuPadding":"Menu Padding",
    "menuThemes":"Menu Themes",
    "menuBorder":"Menu Border",
    "border_active":"Active Border",
    "color":"Color",
    "dropShadow":"Drop Shadow",
    "spread":"Spread",
    "distance":"Distance",
    "blur":"Blur",
    "fixedPosition":"Fixed position",
    "fixedHeaderStyle":"Fixed header style",
    "basic":"Basic",
    "scrollBack":"Scroll Back",
    "headerHeight":"Header Height",
    "layout":"Layout",
    "searchHere":"Search Here",
    "logoImage":"Logo Image",
    "siteTitle":"Site Title",
    "yourSiteTitle":"Your Site Title",
    "badgeColor":"Badge Color",
    "badgeBackground":"Badge Background",
    "video":"Choose Video",
    "maxVideoSize":"Max File size is 100MB",
    "onlyAllowedMp4": "Only MP4 video are allowed",
    "invalidURL":"Please make sure the URL is valid and follows our supported formats:</br>- Direct links to MP4 files.</br>- Video URLs from YouTube, Dailymotion, or Vimeo.",
    "searchOption":"Search Option",
    "headerImageInner":"Disable header image across the inner pages of app",
    "headerText":"Header Text",
    "blurImage":"Blur Header image",
    "notification":"Notification",
    "defaultBG":"Default BG",
    "autoplay":"Autoplay Video",
    "loop":"Loop Video",
    "infoMessage":"Please note: These settings will only take effect on real devices.",
    "infoMessageMobile":"Please note: These settings will only take effect on real mobile devices.",
    "religious":"Religious",
    "itemBorderStyle":"Item Border Style",
    "menuBorderStyle":"Menu Border Style",
    "itemBorderColor":"Item Border Color",
    "menuBorderColor":"Menu Border Color",
    "itemBorderSize":"Item Border Size",
    "menuBorderSize":"Menu Border Size",
    "itemPadding":"Item Padding",
    "cornersType":"Corners Type",
    "hideHeader":"Hide Header",
    "sameImages":"Use the same image for both Portrait and Landscape modes",
    "please_select_a_file":"Please select a file",
    "portrait":"For Portrait",
    "advanced_settings":"Advanced Settings",
    "landscape":"For Landscape",
    "crop_image":"Crop Image",
    "fill_color_opacity":"Fill Color & Opacity",
    "border":"Border",
    "spacing":"Spacing",
    "shadow":"Shadow",
    "settings":"Settings",
    "media_settings":"Media Settings",
    "hyperlink":"Hyperlink",
    "logo_settings":"LOGO SETTINGS",
    "menu_design":"MENU DESIGN",
    "footer_menu_design":"Footer MENU DESIGN",
    "header_icons":"Header Icons",
    "hover":"hover",
    "clicked":"clicked",
    "regular":"regular",
    "cart": "Cart",
    "location": "Location",
    "layoutIcon": "Layout",
    "threeDot": "Three Dot",
    "threeDotVertical": "Vertical Menu",
    "share": "Share",
    "doubleDown": "Down Arrow",
    "menuWithDownArrow": "Down Menu",
    "heart": "Heart",
    "back": "Back",
    "notificationGear": "Notification Settings",
    "menu": "Menu",
    "close": "Close",
    "download": "Download",
    "cross": "Cross",
    "gameSettings": "Settings",
    "refresh": "Refresh",
    "filter": "Filter",
    "emptyHeart": "Empty Heart",
    "fillHeart": "Heart",
    "reset": "Refresh",
    "location_three": "Location Three",
    "bookmark": "Bookmark",
    "icon_info": "Info",
    "iconSpin3": "Spin",
    "appyiconArOne": "AR",
    "iconCogFour": "Cogwheel",
    "iconPost": "Post",
    "iconEdit": "Edit",
    "socialMessengerChat": "Chat",
    "iconSave": "Save",
    "callIcon": "Call",
    "sendIcon": "Send",
    "appynativeCancel": "Cancel",
    "profile": "Profile",
    "skip": "Skip",
    "videocall": "Video Call",
    "iconInvite": "Video Call",
    "iconSchedule": "Schedule",
    "add_email" : "Add email",
    "email_subject": "Add email subject",
    "email_content" : "Add email content",
    "apply_changes_to_all":"Apply changes to all similar elements",
    "menu_settings":"MENU SETTINGS",
    "confirm" : "Confirm",
    "enable_custom_menu" : "Enable Custom Menu",
    "enable_custom_menu_summary" : "Your previous menu will be removed and have to add all the pages manually",
    "menu_items":"MENU ITEMS",
    "add_item":"Add Item",
    "link_to_homepage":"Link to Homepage",
    "link_to_homepage_category":"Link to Specific Category, Subcategory, or Product",
    "no_data_found":"No data found",
    "faviconImage":"Favicon Image",
    "anchor_links":"Anchor Links",
    "rename":"Rename",
    "add_submenu":"Add Submenu",
    "move_under_top":"Move Under Top",
    "move_down":"Move Down",
    "move_outside":"Move Outside",
    "submenu_layout":"Submenu Layout",
    "list":"List",
    "grid":"Grid",
    "menu_type":"Menu Type",
    "link_this_section":"Link this section",
    "hideFooter":"Hide Footer",
    "altText":"Alt Text",
    "type":"Type",
    "you_are_on_preview_mode":"You are on preview mode, to access dashboard and edit project kindly take a",
    "trial": "trial",

    // Manage Menu popup (src/components/ManageMenu.js). The rest of that popup
    // reuses keys already above — text_color, activeColor, background, layout,
    // regular, preview, menu_design, edit, up, down, remove, close,
    // email_subject — so only what had no entry is added here.
    //
    // These reach users only once this pack is saved from /language-settings;
    // until then ManageMenu's t() helper falls back to the same English, so
    // nothing shows a raw key in the meantime.
    "manage_menu": "Manage Menu",
    "custom_menu": "Custom Menu",
    "menu_structure": "Menu structure",
    "close_all": "Close all",
    "link_text": "Link text",
    "menu_item": "Menu item",
    "email_us": "Email us",
    "call_us": "Call us",
    // Outdent / indent. Named for the action rather than the visible "Out" and
    // "In", which are too bare to translate from on their own.
    "menu_outdent": "Out",
    "menu_indent": "In",
    "click_save_hint": "Click Save to add it to the menu.",
    "pick_section_hint": "Pick a section from a page above to link to.",
    "no_pages_available": "No pages available.",
    "no_anchor_pages": "No pages with anchorable sections.",
    "drag_handle": "Drag handle",
    "country_code": "Country code",
}

function beautifyJson(jsonString) {
    try {
        // Parse the JSON string to an object
        var jsonObject = JSON.parse(jsonString);

        // Convert the object back to a formatted JSON string with indentation of 2 spaces
        var beautifiedJsonString = JSON.stringify(jsonObject, null, 4);

        // Return the beautified JSON string
        return beautifiedJsonString;
    } catch (error) {
        // Handle any errors that occurred during parsing or formatting
        console.error("Error beautifying JSON: " + error);
        return null; // or handle the error in a way that makes sense for your application
    }
}

const LandConverter = function({lang,langJson, data}) {
    const [status, setStatus] = useState(lang.status); 
    useEffect(() => {
        setStatus(lang.status)
    }, [lang]);
    const saveItemOld = async function(item) {
        app.preloader(true);
        const texts = [];
        const data = JSON.parse(JSON.stringify(languageSettings));
        for(var key in data) {
            texts.push({
                key,
                text:data[key]
            })
        }

        const response = await fetchLanguage(texts.map(function(v){
            return v.text;
        }), lang.key);

        response.forEach(function(v, i){
            data[texts[i].key] = v;
        });

        await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
            method:"POST",
            body:JSON.stringify({
                "method":"saveLanguage",
                "lang":lang.live,
                "data":data
            })
        });
        app.preloader(false);
        alert("data saved successfully");
        //response = await response.json();
    }
    const saveItem = async function(item) {
        app.preloader(true);

        let otherData = await fetchData({
            "method":"getLanguage",
            "lang":lang.live
        });

        otherData = otherData.languageSettings;
        const misData = findMismatchedKeysWithValues(otherData)
        
        console.log(misData);

        const texts = [];
        const data = JSON.parse(JSON.stringify(misData));
        for(var key in data) {
            texts.push({
                key,
                text:data[key]
            })
        }
        if(texts.length) {
            const response = await fetchLanguage(texts.map(function(v){
                return v.text;
            }), lang.key);
    
          
            response.forEach(function(v, i){
                otherData[texts[i].key] = v;
            });
    
            await fetchData({
                "method":"saveLanguage",
                "lang":lang.live,
                "data":otherData
            });
           
            alert("data saved successfully");
        }
        else {
            alert("no data saved due to mismatch");
        }

        app.preloader(false);

        
        

        
        //response = await response.json();
    }
    const styleSvg = {
        height:"2.5em",
        position: "relative",
        left: "-2px",
        top: "-2px",
        width:"2.5em"
    }

    let loader = "";
    if(status) {
        //loader = <span className="badge bg-success ms-auto">success</span>
        loader =     <svg xmlns="http://www.w3.org/2000/svg" style={styleSvg} width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
        </svg>

    }
    let preview = "";
    if(status) {
        preview =  <a className="btn btn-outline-secondary btn-sm" href={`/desktop-preview/blocks/${lang.id}`}>Preview</a>
    }

    return <li className="list-group-item d-flex align-items-center" style={{height:"50px"}}>
      
        <span>{lang.text} ({lang.live})</span>
        <div className="buttons ms-auto">
        <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => saveItem(data)}>Convert</button>
        {preview}
        </div>
    </li>
}

export default function LanguageSettings(props) {
    const saveItem = async function(){
        app.preloader(true);
        await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
            method:"POST",
            body:JSON.stringify({
                "method":"saveLanguage",
                "lang":"en",
                "data":languageSettings
            })
        });
        app.preloader(false);
    }
    return <div className="container-fluid p-2 w-100 h-100">
   
    <div className="container">
    <div className="w-100 d-flex p-1 mb-3" style={{height:"50px"}}>
        <h4>Language Settings</h4>
    <button className="btn btn-success ms-auto" onClick={saveItem}>{app.getLang("save")}</button> 
    </div>
        
    {
        languages.map(function(v){
            return <LandConverter key={v.key} lang={v} />
        })
    }
    </div>
    </div>
}